import type { CreatePrescriptionOrderDto, GetPrescriptionList, PrescriptionDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { ListResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { SaleOrderDto } from '../sale-order/models';

@Injectable({
  providedIn: 'root',
})
export class PrescriptionService {
  apiName = 'Default';
  

  createSaleOrder = (input: CreatePrescriptionOrderDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SaleOrderDto>({
      method: 'POST',
      url: '/api/app/prescription/sale-order',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  deleteSaleOrder = (saleOrderId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SaleOrderDto>({
      method: 'DELETE',
      url: `/api/app/prescription/sale-order/${saleOrderId}`,
    },
    { apiName: this.apiName,...config });
  

  get = (input: GetPrescriptionList, cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ListResultDto<PrescriptionDto>>({
      method: 'GET',
      url: '/api/app/prescription',
      params: { pharmacyLinkId: input.pharmacyLinkId, dateFrom: input.dateFrom, dateTo: input.dateTo, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getSaleOrder = (saleOrderId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SaleOrderDto>({
      method: 'GET',
      url: `/api/app/prescription/sale-order/${saleOrderId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
